module.exports = __webpack_public_path__ + "img/enterprise-network-solutionsimg-1.6e726337.png";